'esversion: 6';

// IMAGES
import 'unicorn-design-system/assets/icons/icons.svg';
import 'unicorn-design-system/assets/images/logo-symbol.svg';
